<template>
  <div>
    <el-dialog
        title="新增组"
        :visible.sync="dialogVisible"
        width="400px"
        top="25vh"
        :append-to-body="true"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        custom-class="full-dialog"
    >
      <el-form style="padding: 20px" ref="stuInfo" :model="json" :rules="rules" size="small" label-width="100px"
               label-position="top">
        <el-form-item label="学生名字列表" prop="names">
          <el-input v-model="json.names" type="textarea" placeholder="请输入学生名字列表 空格隔开"
                    :autosize="{minRows: 4, maxRows: 4}" :style="{width: '100%'}"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handelConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  components: {},
  props: [],
  data() {
    return {
      groupId:'',
      dialogVisible:false,
      json: {
        names: undefined,
      },
      rules: {
        names: [{
          required: true,
          message: '请输入学生名字列表 空格隔开',
          trigger: 'blur'
        }],
      },
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    onOpen(id) {
      this.groupId = id;
      console.log(id);
      this.dialogVisible=true;
    },
    onClose() {
      this.$refs['stuInfo'].resetFields()
    },
    close() {
      this.dialogVisible=false;
    },
    handelConfirm() {
      let _this = this;
      this.$refs['stuInfo'].validate(valid => {
        if (!valid) return
        this.sa.ajax('api/psdAdmin/des/desStuImport',
            {
              names:_this.json.names,
              id:_this.groupId
            },
            function(res){
              if(res.code==0){
                _this.dialogVisible=false;
              }else{
                this.sa.error(res.msg || '创建失败');
              }
            }.bind(this));
      })
    },
  }
}

</script>
<style>
</style>
